import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
const INVALID_SKU = `Sorry... this isn't a valid sku.`;
export const InvalidSku = () => {
    return (_jsx(Box, { children: _jsx(Typography, { children: INVALID_SKU }) }));
};
